var spoiler_default = {
  "fontElementMap": "fBrDw",
  "hideText": "_6Pvai",
  "onHoverText": "_9P6yF",
  "hideBlock": "iP-H2",
  "smallBlur": "TJ5KH",
  "mediumBlur": "o3e5D",
  "largeBlur": "yX-Rc",
  "hideBlock_gallery": "_8k2cL",
  "overlay": "jmjf8",
  "overlay_gallery": "t1uhA",
  "revealSpoilerBtn": "h0s3A",
  "isMobile": "ZV5Ya",
  "onHoverBtn": "ZNPuc",
  "spoilerWrapper": "o8H9N",
  "spoilerDescription": "cYn7g",
  "spoilerContainer": "GRIzH",
  "spoilerContainer_Gallery": "TYIKY"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
